import { FormEntry, FormSelect, FormTextArea } from "components";
import { examinations, languages } from "../constants";
import { Row, Col } from "reactstrap";

export const OptionalFields = ({ register, errors, editable }) => (
  <Row>
    <Col sm={12}>
      <FormTextArea
        register={register}
        formLabel="Additional Info"
        placeholder="Additional Info"
        name="additionalInfo"
        error={errors.additionalInfo}
      />
    </Col>
    <Col sm={12}>
      <FormTextArea
        register={register}
        formLabel="Background Info"
        placeholder="Background Info"
        name="backgroundInformation"
        error={errors.backgroundInformation}
      />
    </Col>
    <Col>
      <div className="text-light ml-2 mb-2">
        <small>Optional</small>
      </div>
      <FormEntry
        formLabel="DOB"
        register={register}
        name="dob"
        error={errors.dob}
        placeholder="Student Age"
        type="date"
      />
      <FormEntry
        formLabel="Car Number Plate 1"
        placeholder="Student parent car number plate 1"
        type="text"
        register={register}
        name="carNumber1"
        error={errors.carNumber1}
      />
      <FormEntry
        formLabel="Car Number Plate 2"
        placeholder="Student parent car number plate 1"
        type="text"
        register={register}
        name="carNumber2"
        error={errors.carNumber2}
      />
      <FormEntry
        formLabel="Birthday"
        placeholder="Birthday"
        type="date"
        register={register}
        name="birthday"
        error={errors.birthday}
      />
      <FormEntry
        formLabel="Student's Email"
        placeholder="Student's Email"
        type="email"
        register={register}
        name="email"
        error={errors.email}
      />
      <FormSelect
        formLabel="Primary Language"
        register={register}
        options={languages}
        error={errors.primaryLanguage}
        name="primaryLanguage"
      />
      <FormEntry
        formLabel="Current School"
        placeholder="Current School"
        type="text"
        register={register}
        name="currentSchool"
        error={errors.currentSchool}
      />
      <FormEntry
        formLabel="Current Grade"
        placeholder="Current Grade"
        type="text"
        register={register}
        name="currentGrade"
        error={errors.currentGrade}
      />
      <FormSelect
        formLabel="Public exams to be taken"
        register={register}
        options={examinations}
        error={errors.publicExams}
        name="publicExams"
      />
      <FormEntry
        formLabel="Personality Type"
        placeholder="Personality"
        type="text"
        register={register}
        name="personalityType"
        error={errors.personalityType}
      />
      <FormEntry
        formLabel="Parent's Special Request"
        placeholder="Request"
        type="text"
        register={register}
        name="specialRequest"
        error={errors.specialRequest}
      />
      <FormEntry
        formLabel="Allergies / Medical Conditions"
        placeholder="Allergies"
        type="text"
        register={register}
        name="allergiesCondition"
        error={errors.allergiesCondition}
      />
      <FormEntry
        formLabel="NFT Path"
        placeholder="Link"
        type="text"
        register={register}
        name="nftPath"
        error={errors.nftPath}
      />
    </Col>
    <Col>
      <div className="text-light ml-2 mb-2">
        <small>Optional</small>
      </div>
      <FormEntry
        formLabel="Favourite Subjects"
        placeholder="Subjects"
        type="text"
        register={register}
        name="favouriteSubjects"
        error={errors.favouriteSubjects}
      />
      <FormEntry
        formLabel="Least Favourite Subjects"
        placeholder="Least Favourite Subject"
        type="text"
        register={register}
        name="leastFavouriteSubjects"
        error={errors.leastFavouriteSubjects}
      />
      <FormEntry
        formLabel="Favourite Colour"
        placeholder="Colour"
        type="text"
        register={register}
        name="favouriteColour"
        error={errors.favouriteColour}
      />
      <FormEntry
        formLabel="Favourite Food"
        placeholder="Food"
        type="text"
        register={register}
        name="favouriteFood"
        error={errors.favouriteFood}
      />
      <FormEntry
        formLabel="Favourite Animal"
        placeholder="Animal"
        type="text"
        register={register}
        name="favouriteAnimal"
        error={errors.favouriteAnimal}
      />
      <FormEntry
        formLabel="Favourite Hobby"
        placeholder="Hobby"
        type="text"
        register={register}
        name="favouriteHobby"
        error={errors.favouriteHobby}
      />
      <FormEntry
        formLabel="Favourite Video Games"
        placeholder="Video Games"
        type="text"
        register={register}
        name="favouriteVideoGames"
        error={errors.favouriteVideoGames}
      />
      <FormEntry
        formLabel="Favourite Movies"
        placeholder="Movies"
        type="text"
        register={register}
        name="favouriteMovies"
        error={errors.favouriteMovies}
      />
      <FormEntry
        formLabel="Favourite Sport"
        placeholder="Sport"
        type="text"
        register={register}
        name="favouriteSport"
        error={errors.favouriteSport}
      />
    </Col>
  </Row>
);
